import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { Iconify } from 'src/components';
import {
  stickyFooterSx,
  footerLeftSx,
  footerRightSx,
  btnBackSx,
  btnSkipSx,
  btnSaveSx,
  btnNextSx,
} from '../styles';

const StickyFooter = ({
  onBack,
  onSkip,
  onSave,
  onNext,
  isBackDisabled = false,
  isNextDisabled = false,
  isComplete = false,
  nextLabel = 'Continue',
  showSkip = true,
  showSave = true,
  showKeyboardHint = true,
  saveAdornment = null,
}) => (
    <Box sx={stickyFooterSx}>
      <Box sx={footerLeftSx}>
        <Button
          onClick={onBack}
          disabled={isBackDisabled}
          sx={btnBackSx}
        >
          <Iconify icon="mdi:arrow-left" width={18} height={18} />
          <Typography
            component="span"
            sx={{ display: { xs: 'none', sm: 'inline' } }}
          >
            Back
          </Typography>
        </Button>

        {showSkip && (
          <Button onClick={onSkip} sx={btnSkipSx}>
            <Iconify icon="mdi:redo" width={18} height={18} />
            <Typography
              component="span"
              sx={{ display: { xs: 'none', sm: 'inline' } }}
            >
              Skip
            </Typography>
          </Button>
        )}

        {showSave && (
          <Button onClick={onSave} sx={btnSaveSx} title="Save progress (Ctrl+S)">
            <Iconify icon="mdi:content-save" width={18} height={18} />
            <Typography
              component="span"
              sx={{ display: { xs: 'none', sm: 'inline' } }}
            >
              Save
            </Typography>
          </Button>
        )}

        {/* Optional adornment rendered immediately to the right of Save.
            Used by CallScriptV2 to host the per-user hint visibility chips. */}
        {saveAdornment}
      </Box>

      <Box sx={footerRightSx}>
        {onNext && (
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            sx={btnNextSx(isComplete)}
          >
            {nextLabel}
            <Iconify icon="mdi:arrow-right" width={18} height={18} />
          </Button>
        )}

        {showKeyboardHint && onNext && (
          <Typography
            sx={{
              fontSize: 10,
              color: '#919EAB',
              display: { xs: 'none', md: 'block' },
            }}
          >
            <Box
              component="kbd"
              sx={{
                padding: '2px 6px',
                bgcolor: '#EEEEEE',
                borderRadius: '4px',
                fontFamily: 'inherit',
              }}
            >
              Enter
            </Box>
          </Typography>
        )}
      </Box>
    </Box>
  );

StickyFooter.propTypes = {
  onBack: PropTypes.func,
  onSkip: PropTypes.func,
  onSave: PropTypes.func,
  onNext: PropTypes.func,
  isBackDisabled: PropTypes.bool,
  isNextDisabled: PropTypes.bool,
  isComplete: PropTypes.bool,
  nextLabel: PropTypes.string,
  showSkip: PropTypes.bool,
  showSave: PropTypes.bool,
  showKeyboardHint: PropTypes.bool,
  saveAdornment: PropTypes.node,
};

export default StickyFooter;
